import React from 'react';
import { css } from '@emotion/core';
import { history } from '../../../redux/store/history';
import {
  OTHER,
  FEATURE_FLAGS,
  OUTAGE_ALERTS,
  USER_LOOKUP,
  ROLES_PERMISSIONS,
  PROVISION_LOCATIONS,
  injectParams,
  SECURITY,
  ORG_MERGE,
  WETAGS,
  SSO_STATS,
} from '../../../constants/paths';
import ProfileIcon from '../../../images/wv-icon-profile.svg';
import { WeaveTheme } from '@weave/theme-original';
import {
  LogOutIcon,
  UpdatesIcon,
  useFlyoutMenu,
  UserIcon,
  WarningBadgeIcon,
  CheckIcon,
  FormsIcon,
  SearchIcon,
  PhoneCallIcon,
  PortingStatusIcon,
  LocationIcon,
  BlockIcon,
  LabelIcon,
  BuildingIcon,
} from '@weave/design-system';
import { useAuth } from '../../../providers/auth.provider';
import { useSelector } from 'react-redux';
import {
  selectIsAuthenticated,
  selectHasWeaveAcl,
} from '../../../redux/actions/auth/auth.selectors';
import { CoreACLs } from '../../../redux/actions/auth/auth.types';
import { Store } from '../../../redux/store/store.model';

export const ProfileInfo = () => {
  const { active, FlyoutMenu, flyoutProps, triggerProps } = useFlyoutMenu();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasOrgMergeAccess = useSelector((state: Store) =>
    selectHasWeaveAcl(state, CoreACLs.ORG_MERGE_MANAGE)
  );

  const hasWetagsAccess = useSelector((state: Store) =>
    selectHasWeaveAcl(state, CoreACLs.FEATURE_FLAG_SET_LOCATION)
  );

  const { handleSignOut } = useAuth();

  const handleOutageAlerts = () => {
    history.push(OUTAGE_ALERTS);
  };

  const gotoPage = (page: string) => {
    history.push(page);
  };

  const gotoUserConfig = () => {
    gotoPage(OTHER.userConfig);
  };
  const gotoAudits = () => {
    gotoPage(OTHER.auditLogsGlobal);
  };
  const gotoDesktopReleases = () => {
    gotoPage(OTHER.DesktopReleases);
  };
  const goToPortabilityCheck = () => {
    gotoPage(OTHER.portabilityCheck);
  };
  const gottoE911Dashboard = () => {
    gotoPage(OTHER.e911Dashboard);
  };

  const goToNwxAnnouncementConsole = () => {
    gotoPage(OTHER.announcementConsole);
  };

  const actions = [
    {
      Icon: UserIcon,
      label: 'User Config',
      onClick: gotoUserConfig,
    },
    {
      Icon: CheckIcon,
      label: 'Feature Flags',
      onClick: () => {
        gotoPage(FEATURE_FLAGS);
      },
    },
    {
      Icon: PhoneCallIcon,
      label: 'E911 dashbaord',
      onClick: gottoE911Dashboard,
    },
    {
      Icon: PortingStatusIcon,
      label: 'Portability Check',
      onClick: goToPortabilityCheck,
    },
    {
      Icon: UpdatesIcon,
      label: 'Desktop Releases',
      onClick: gotoDesktopReleases,
    },
    {
      Icon: WarningBadgeIcon,
      label: 'Outage Alerts',
      onClick: handleOutageAlerts,
    },
    {
      Icon: UpdatesIcon,
      label: 'Announcement Console',
      onClick: goToNwxAnnouncementConsole,
    },
    {
      Icon: FormsIcon,
      label: 'Audit Logs',
      onClick: gotoAudits,
    },
    {
      Icon: SearchIcon,
      label: 'User Look Up',
      onClick: () => {
        gotoPage(USER_LOOKUP);
      },
    },
    {
      Icon: CheckIcon,
      label: 'Roles & Permissions',
      onClick: () => {
        gotoPage(ROLES_PERMISSIONS);
      },
    },
    {
      Icon: BuildingIcon,
      label: 'SSO Stats',
      onClick: () => {
        gotoPage(SSO_STATS);
      },
    },
    {
      Icon: LocationIcon,
      label: 'Provision Locations',
      onClick: () => {
        gotoPage(
          injectParams(PROVISION_LOCATIONS, {
            slug: '',
          })
        );
      },
      disabled: true,
    },
    {
      Icon: BlockIcon,
      label: 'Block Users',
      onClick: () => {
        gotoPage(SECURITY.root);
      },
    },
    {
      Icon: LocationIcon,
      label: 'Org Merge',
      onClick: () => {
        gotoPage(ORG_MERGE);
      },
      disabled: !hasOrgMergeAccess,
    },
    {
      Icon: LabelIcon,
      label: 'Wetags',
      onClick: () => {
        gotoPage(WETAGS.root);
      },
      disabled: !hasWetagsAccess,
    },
    {
      Icon: LogOutIcon,
      label: 'Sign Out',
      onClick: handleSignOut,
    },
  ];

  return (
    <div style={{ display: isAuthenticated ? 'flex' : 'none' }}>
      <button
        css={css`
          &:focus,
          &:active {
            outline: none;
          }
        `}
        data-testid={'profile-btn'}
        {...triggerProps}
      >
        <img alt="" src={ProfileIcon} />
      </button>
      {active && (
        <FlyoutMenu
          {...flyoutProps}
          actions={actions}
          css={(theme: WeaveTheme) =>
            css`
              box-shadow: ${theme.shadows.heavy};
              min-width: 200px;
              right: 0;
              top: 100%;
              max-height: calc(100vh - 64px);
              overflow-y: auto;
              overflow-x: hidden;
            `
          }
        />
      )}
    </div>
  );
};
